import { useCallback, useState } from 'react';
import CreateViewModal from 'framework-listing-lib/internal/ViewTabs/components/CreateViewModal';
import useCrmObjectTypeTracking from 'framework-listing-lib/internal/hooks/useCrmObjectTypeTracking';
import SaveViewButton from 'framework-listing-lib/internal/ViewTabs/components/SaveViewButton';
import useCrmObjectTypeListingSort from 'framework-listing-lib/internal/hooks/useCrmObjectTypeListingSort';
import useCrmObjectTypeListingFilters from 'framework-listing-lib/hooks/useCrmObjectTypeListingFilters';
import { useSaveView } from 'framework-listing-lib/internal/ViewTabs/hooks/useMutateViews';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
import useCurrentView from 'framework-listing-lib/hooks/useCurrentView';
import { useOnViewIdChange, useViewsNamespace } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
import useViewForm from '../hooks/useViewForm';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CrmListingSaveViewButton() {
  const {
    trackCrmTableInteraction
  } = useCrmObjectTypeTracking();
  const currentView = useCurrentView();
  const namespace = useViewsNamespace();
  const onViewIdChange = useOnViewIdChange();
  const {
    onSetSort
  } = useCrmObjectTypeListingSort();
  const {
    onResetFilters
  } = useCrmObjectTypeListingFilters();
  const objectType = useObjectTypeId();
  const {
    saveView,
    loading
  } = useSaveView();
  const [showCloneModal, setShowCloneModal] = useState(false);
  const buildViewUpdate = useViewForm();
  const handleViewSaved = useCallback(viewId => {
    setShowCloneModal(false);
    onViewIdChange(viewId);
    trackCrmTableInteraction({
      action: 'change-view',
      viewId
    });
  }, [onViewIdChange, trackCrmTableInteraction]);
  const handleSaveAsNewClick = useCallback(() => {
    trackCrmTableInteraction({
      action: 'click-save-as-new',
      isDefaultView: true
    });
    setShowCloneModal(true);
  }, [trackCrmTableInteraction]);
  const handleSaveView = useCallback(() => {
    if (loading) {
      return;
    }
    const viewUpdate = buildViewUpdate('UPDATE');
    saveView(viewUpdate).catch(() => {
      // Error is being handled by useMutateViews
    });
  }, [loading, saveView, buildViewUpdate]);
  const handleResetClick = useCallback(() => {
    if (!currentView) {
      return;
    }
    onResetFilters();
    onSetSort([{
      id: currentView.state.sortKey,
      desc: currentView.state.order === 1
    }]);
  }, [currentView, onSetSort, onResetFilters]);
  const saveViewButton = /*#__PURE__*/_jsx(SaveViewButton, {
    onCloneClick: handleSaveAsNewClick,
    onResetClick: handleResetClick,
    onSaveClick: handleSaveView
  });
  if (!currentView) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showCloneModal && /*#__PURE__*/_jsx(CreateViewModal, {
      formType: "CLONE_WITH_CHANGES",
      namespace: namespace,
      objectTypeId: objectType,
      onClose: () => setShowCloneModal(false),
      onCreate: handleViewSaved
    }), saveViewButton]
  });
}